import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'
import StyledReactSelect from '../user_advanced_filters/custom_dropdown/StyledReactSelect'
import styles from './UserFilters.module.scss'

export const UserFilters = ({ appliedFilters, filterOptions, onFilterChange }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('filters.filterBy'))
    setBtns([{ text: t('buttons.apply'), onClick: onClose }])
  }, [])

  return (
    <div className={styles['container']}>
      {filterOptions.map(({ key, label, options, isMulti }, i) => (
        <div key={`${key}-${i}`} className={styles['select']}>
          <StyledReactSelect
            options={options}
            label={label}
            value={appliedFilters?.[key]}
            ariaLabel={label}
            onChange={(selected) => {
              onFilterChange?.(key, selected)
            }}
            placeholder={t('form.select.select')}
            isMulti={isMulti}
          />
        </div>
      ))}
    </div>
  )
}
